const orthodontics = {
  hero: {
    titlePrefix: "Σύγχρονη",
    titleAccent: "Ορθοδοντική",
    titleSuffix: "Για Ένα Τέλειο Χαμόγελο",
    description:
      "Αποκτήστε τέλεια ευθυγράμμιση και ένα λαμπερό χαμόγελο με τις καινοτόμες ορθοδοντικές μας θεραπείες. Η εξειδικευμένη ομάδα μας χρησιμοποιεί την πιο πρόσφατη τεχνολογία για να προσφέρει άνετες και αποτελεσματικές λύσεις για όλες τις ηλικίες.",
    ctas: {
      primary: "Κλείστε Ραντεβού",
      secondary: "Μάθετε περισσότερα",
    },
    patientAlt: "Happy Patient",
    patientCount: "1000+ Ευχαριστημένοι Ασθενείς",
    rating: "Αξιολόγηση: 4.9 / 5",
    imageAlt: "Advanced Orthodontic Treatment",
    tech: {
      calloutTitle: "Σύγχρονες Τεχνικές",
      calloutSubtitle: "Ασφαλείς & Άνετες",
    },
  },
  benefits: {
    heading: "Γιατί να Επιλέξετε την Ορθοδοντική Μας Φροντίδα",
    intro:
      "Ζήστε την εμπειρία ολοκληρωμένων ορθοδοντικών θεραπειών με έμφαση στην άνεση, την αισθητική και τα μακροπρόθεσμα αποτελέσματα.",
    items: [
      {
        title: "Τέλεια Ευθυγράμμιση",
        description:
          "Αποκτήστε τέλεια ευθυγραμμισμένα δόντια για ένα όμορφο χαμόγελο και βελτιωμένη λειτουργία δαγκώματος.",
      },
      {
        title: "Καλύτερη Στοματική Υγεία",
        description:
          "Τα ίσια δόντια καθαρίζονται ευκολότερα, μειώνοντας τον κίνδυνο τερηδόνας και ουλίτιδας.",
      },
      {
        title: "Σύγχρονη Τεχνολογία",
        description:
          "Επωφεληθείτε από μικρότερους χρόνους θεραπείας χάρη στις προηγμένες τεχνολογίες μας.",
      },
      {
        title: "Εξατομικευμένη Αντιμετώπιση",
        description:
          "Εξατομικευμένα πλάνα θεραπείας, προσαρμοσμένα στις δικές σας ανάγκες και στόχους.",
      },
    ],
  },
  process: {
    heading: "Η Ορθοδοντική Μας Διαδικασία",
    intro:
      "Μια οργανωμένη και άνετη διαδρομή προς το τέλειο χαμόγελο με την εξειδικευμένη ορθοδοντική μας ομάδα.",
    imageAlt: "Ορθοδοντική Διαδικασία Θεραπείας",
    calloutTitle: "Εξειδικευμένη Φροντίδα",
    calloutSubtitle: "Έμπειροι Ειδικοί",
    items: [
      {
        title: "Αρχική Ανάλυση",
        description:
          "Λεπτομερής εξέταση της οδοντικής σας δομής για να αξιολογήσουμε τις ανάγκες σας και να συζητήσουμε τις θεραπευτικές επιλογές.",
      },
      {
        title: "Εξατομικευμένο Πλάνο Θεραπείας",
        description:
          "Δημιουργία ενός προσωποποιημένου σχεδίου ορθοδοντικής θεραπείας προσαρμοσμένου στις δικές σας ανάγκες ευθυγράμμισης.",
      },
      {
        title: "Ενεργή Θεραπεία",
        description:
          "Τακτικά ραντεβού για ρυθμίσεις, ώστε να διασφαλιστεί ότι η θεραπεία σας εξελίσσεται σύμφωνα με το πλάνο.",
      },
      {
        title: "Φάση Διατήρησης",
        description:
          "Διατήρηση του νέου σας χαμόγελου με εξατομικευμένους νάρθηκες μετά την ολοκλήρωση της ενεργής θεραπείας.",
      },
    ],
  },
  faq: {
    heading: "Συχνές Ερωτήσεις",
    intro:
      "Βρείτε απαντήσεις σε συχνές ερωτήσεις σχετικά με τις ορθοδοντικές μας θεραπείες",
    items: [
      {
        question: "Πόσο διαρκεί συνήθως η ορθοδοντική θεραπεία;",
        answer:
          "Η διάρκεια της θεραπείας διαφέρει ανάλογα με τις ανάγκες του κάθε ατόμου, αλλά συνήθως κυμαίνεται από 12 έως 36 μήνες. Παράγοντες που επηρεάζουν τη διάρκεια είναι η σοβαρότητα των προβλημάτων ευθυγράμμισης, η ηλικία του ασθενούς και η συνέπεια στη θεραπεία.",
      },
      {
        question: "Τι είδη σιδεράκια και ορθοδοντικές επιλογές προσφέρετε;",
        answer:
          "Προσφέρουμε μια πλήρη γκάμα επιλογών όπως μεταλλικά σιδεράκια, διάφανα κεραμικά σιδεράκια, αυτόδετα σιδεράκια και διάφανους νάρθηκες τύπου Invisalign. Κατά τη διάρκεια της εξέτασης, θα προτείνουμε την καλύτερη επιλογή για την περίπτωσή σας.",
      },
      {
        question: "Είναι επώδυνες οι ορθοδοντικές θεραπείες;",
        answer:
          "Ίσως αισθανθείτε ήπια ενόχληση ή πίεση μετά από ρυθμίσεις, αλλά οι σύγχρονες ορθοδοντικές τεχνικές έχουν σχεδιαστεί για να ελαχιστοποιούν τον πόνο. Η ενόχληση συνήθως υποχωρεί μέσα σε λίγες ημέρες και μπορεί να αντιμετωπιστεί με απλά παυσίπονα.",
      },
      {
        question: "Κάθε πότε θα χρειάζονται ρυθμίσεις;",
        answer:
          "Οι περισσότεροι ασθενείς χρειάζονται ρυθμίσεις κάθε 4 έως 8 εβδομάδες, ανάλογα με τον τύπο της θεραπείας και την πρόοδο. Θα δημιουργήσουμε ένα εξατομικευμένο πρόγραμμα για τη θεραπεία σας.",
      },
      {
        question: "Τι συμβαίνει μετά την αφαίρεση;",
        answer:
          "Μετά την ολοκλήρωση της θεραπείας, ξεκινά η φάση διατήρησης. Θα σας χορηγηθούν νάρθηκες (retainers) για να διατηρηθεί το νέο σας χαμόγελο. Αρχικά θα τους φοράτε όλη την ημέρα και σταδιακά μόνο κατά τη διάρκεια της νύχτας. Θα πραγματοποιούνται τακτικοί έλεγχοι για την παρακολούθηση των αποτελεσμάτων.",
      },
    ],
    bottomLine: "Έχετε ακόμα ερωτήσεις; Είμαστε εδώ για να βοηθήσουμε!",
    cta: "Επικοινωνήστε Μαζί Μας",
  },
};

export default orthodontics;

